import axios, { isAxiosError } from "axios";
import { vpnManagerUrlEnvVar } from "@src/cloud-connect/feature-toggles/feature-toggles";
import { buildAxiosAuthenticationHeaders } from "@src/cloud-connect/api/util/build-axios-authentication-headers";

export interface postVPNAcceptSupportSessionDto {
  namespace: string;
  id: string;
  requestedDuration?: string;
}

export const postVPNAcceptSupportSession = async (
  payload: postVPNAcceptSupportSessionDto,
) => {
  const url = vpnManagerUrlEnvVar();
  const headers = buildAxiosAuthenticationHeaders();

  const { namespace, id, requestedDuration } = payload;

  try {
    const response = await axios.post(
      `${url}/api/v1/ns/${namespace}/support-sessions/${id}/accept`,
      { approved_duration: requestedDuration },
      { headers },
    );

    return response?.data;
  } catch (err) {
    if (isAxiosError(err)) {
      console.error("Axios error:", err);
      throw new Error(
        err.response?.data?.detail ||
          err.response?.data?.message ||
          "Failed to accept support session. Please try again later.",
      );
    } else {
      throw new Error(
        "An unexpected error occurred while accepting support session.",
      );
    }
  }
};
